<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">a) What is the relationship between the two compounds shown below?</p>

      <p class="mb-2 pl-12">
        <v-img
          :src="$publicAsset('/img/assignments/laurierSandboxStructuresQuestion5.png')"
          alt=""
          max-width="319px"
        />
      </p>

      <v-radio-group v-model="inputs.multipleChoiceAnswer" :disabled="!allowEditing">
        <v-radio v-for="option in options" :key="option.value" class="my-1" :value="option.value">
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-2 mt-2">b) I think this because:</p>

      <p class="mb-n6">
        <s-textarea v-model="inputs.explainedResponse" outlined />
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import STextarea from '@/common/components/STextarea.vue';

export default {
  name: 'LaurierSandboxQ5',
  components: {
    STextarea,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        multipleChoiceAnswer: null,
        explainedResponse: null,
      },
      options: [
        {
          text: 'Identical (includes different conformations of the same compound)',
          value: 'identical',
        },
        {text: 'Enantiomers', value: 'enantiomers'},
        {text: 'Diastereomers', value: 'diastereomers'},
        {text: 'Constitutional isomers', value: 'constitutionalIsomers'},
      ],
    };
  },
};
</script>
